import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { RechtlicheSeite, rechtlicheSeiteFuerPfad } from './features/rechtliches/RechtlicheSeite';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
// Welle U10: /impressum und /datenschutzerklaerung sind öffentlich — sie werden
// VOR der App gewählt, damit weder Anmeldung noch App-Logik anlaufen.
const rechtlich = rechtlicheSeiteFuerPfad(window.location.pathname);
root.render(
  <React.StrictMode>
    {rechtlich ? <RechtlicheSeite art={rechtlich} /> : <App />}
  </React.StrictMode>
);

reportWebVitals();

// ── Service Worker registrieren (PWA) ─────────────────────────────────────
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {/* silent */});
  });
}
